import React from 'react';
import './MediaAsset.css';

function MediaAsset({ 
  src, 
  className = 'engagement-photo', 
  alt = 'Engagement media',
  heightPercent = 100, // Default to showing full height
  shiftPercent = 0, // Default to no shift
  overlayText = '', // Keep original default
  overlayContent = null // New prop for custom content
}) {
  const isVideo = src.toLowerCase().endsWith('.mp4');
  
  const containerStyle = {
    height: `${heightPercent}vh`, // Container height matches content height
  };

  const mediaStyle = {
    objectPosition: `center ${shiftPercent}%`
  };

  return (
    <div 
      style={containerStyle} 
      className={`media-asset-container ${className}`}
    >
      {isVideo ? (
        <video 
          src={src}
          alt={alt}
          style={mediaStyle}
          className="media-asset"
          autoPlay
          muted
          loop
        />
      ) : (
        <img 
          src={src} 
          alt={alt} 
          style={mediaStyle}
          className="media-asset"
        />
      )}
      {(overlayText || overlayContent) && (
        <div className="media-asset-overlay">
          {overlayContent ? (
            overlayContent
          ) : (
            overlayText && <h2>{overlayText}</h2>
          )}
        </div>
      )}
    </div>
  );
}

export default MediaAsset; 